import { d as S } from "../differenceInCalendarDays-BtfJmFUw.js";
import { t as a, a as _, e as F, g as m, c as p, d as h } from "../en-US-DzLLmR2o.js";
function M(t, n) {
  const e = a(t), o = a(n), s = e.getTime() - o.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function Y(t, n) {
  const e = a(t), o = a(n), s = e.getFullYear() - o.getFullYear(), c = e.getMonth() - o.getMonth();
  return s * 12 + c;
}
function w(t, n) {
  const e = a(t), o = a(n), s = x(e, o), c = Math.abs(S(e, o));
  e.setDate(e.getDate() - s * c);
  const f = +(x(e, o) === -s), r = s * (c - f);
  return r === 0 ? 0 : r;
}
function x(t, n) {
  const e = t.getFullYear() - n.getFullYear() || t.getMonth() - n.getMonth() || t.getDate() - n.getDate() || t.getHours() - n.getHours() || t.getMinutes() - n.getMinutes() || t.getSeconds() - n.getSeconds() || t.getMilliseconds() - n.getMilliseconds();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
function O(t) {
  return (n) => {
    const e = Math.trunc, o = e(n);
    return o === 0 ? 0 : o;
  };
}
function b(t, n) {
  return +a(t) - +a(n);
}
function X(t) {
  const n = a(t);
  return n.setHours(23, 59, 59, 999), n;
}
function H(t) {
  const n = a(t), e = n.getMonth();
  return n.setFullYear(n.getFullYear(), e + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function N(t) {
  const n = a(t);
  return +X(n) == +H(n);
}
function z(t, n) {
  const e = a(t), o = a(n), s = M(e, o), c = Math.abs(
    Y(e, o)
  );
  let f;
  if (c < 1)
    f = 0;
  else {
    e.getMonth() === 1 && e.getDate() > 27 && e.setDate(30), e.setMonth(e.getMonth() - s * c);
    let r = M(e, o) === -s;
    N(a(t)) && c === 1 && M(t, o) === 1 && (r = !1), f = s * (c - Number(r));
  }
  return f === 0 ? 0 : f;
}
function j(t, n, e) {
  const o = b(t, n) / 1e3;
  return O()(o);
}
function W(t, n, e) {
  const o = _(), s = (e == null ? void 0 : e.locale) ?? o.locale ?? F, c = 2520, f = M(t, n);
  if (isNaN(f))
    throw new RangeError("Invalid time value");
  const r = Object.assign({}, e, {
    addSuffix: e == null ? void 0 : e.addSuffix,
    comparison: f
  });
  let d, g;
  f > 0 ? (d = a(n), g = a(t)) : (d = a(t), g = a(n));
  const I = j(g, d), v = (m(g) - m(d)) / 1e3, i = Math.round((I - v) / 60);
  let l;
  if (i < 2)
    return i === 0 ? s.formatDistance("lessThanXMinutes", 1, r) : s.formatDistance("xMinutes", i, r);
  if (i < 45)
    return s.formatDistance("xMinutes", i, r);
  if (i < 90)
    return s.formatDistance("aboutXHours", 1, r);
  if (i < p) {
    const u = Math.round(i / 60);
    return s.formatDistance("aboutXHours", u, r);
  } else {
    if (i < c)
      return s.formatDistance("xDays", 1, r);
    if (i < h) {
      const u = Math.round(i / p);
      return s.formatDistance("xDays", u, r);
    } else if (i < h * 2)
      return l = Math.round(i / h), s.formatDistance("aboutXMonths", l, r);
  }
  if (l = z(g, d), l < 12) {
    const u = Math.round(i / h);
    return s.formatDistance("xMonths", u, r);
  } else {
    const u = l % 12, D = Math.trunc(l / 12);
    return u < 3 ? s.formatDistance("aboutXYears", D, r) : u < 9 ? s.formatDistance("overXYears", D, r) : s.formatDistance("almostXYears", D + 1, r);
  }
}
const L = (t) => {
  let n;
  try {
    const e = new Date(t), o = /* @__PURE__ */ new Date();
    if (w(o, e) > 128)
      return e.toLocaleDateString();
    n = `${W(o, e)} ago`;
  } catch {
    return t;
  }
  return n;
}, E = (t) => t.startsWith("image/") ? "img" : t === "application/pdf" ? "pdf" : t === "application/vnd.ms-excel" || t === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "xsl" : t === "application/msword" || t === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? "doc" : t === "application/vnd.ms-powerpoint" || t === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? "ppt" : t === "application/zip" || t === "application/x-zip-compressed" ? "zip" : t.startsWith("audio/") ? "audio" : t.startsWith("video/") ? "video" : t === "text/plain" ? "txt" : t === "application/json" || t === "application/xml" || t.startsWith("text/") || t.includes("javascript") || t.includes("json") || t.includes("typescript") ? "code" : "misc";
export {
  L as formatMessageTimestamp,
  E as getFileTypeFromMime
};
